import { render, staticRenderFns } from "./Popup01.vue?vue&type=template&id=46789b86&scoped=true"
import script from "./Popup01.vue?vue&type=script&lang=js"
export * from "./Popup01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46789b86",
  null
  
)

export default component.exports